// extracted by mini-css-extract-plugin
export default {"consumer_tag":"PayPerListingPackage_consumer_tag__f1Z86"};